import { ErrorOutlineOutlined, GetApp } from '@mui/icons-material'
import { Box } from '@mui/material'
import React, { ReactNode } from 'react'
import { useStyles } from './styles'

interface AlertBoxProps {
  title: string
  subTitle: ReactNode | string
  actionText: string
  onActionClick: () => void
}

const AlertBox: React.FC<AlertBoxProps> = ({ actionText, onActionClick, subTitle, title }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Box className={classes.container}>
        <ErrorOutlineOutlined
          color='info'
          fontSize='small'
        />
        <Box className={classes.content}>
          <strong>{title}</strong>
          <span>{subTitle}</span>
        </Box>
      </Box>

      <Box
        className={classes.action}
        onClick={onActionClick}
      >
        <GetApp
          fontSize='small'
          color='primary'
        />
        <strong>{actionText}</strong>
      </Box>
    </Box>
  )
}

export default AlertBox
